export type UpdatePartnerResponse = {
  /**
   * Status
   */
  status: string;

  /**
   * Error
   */
  error: string;

  /**
   * Message List
   */
  message: Message[];
};

type Message = {
  /**
   * Error ID
   */
  errorId: string;

  /**
   * Message ID
   */
  messageId: string;

  /**
   * Message
   */
  message: string;

  /**
   * Details
   */
  details: Detail[];
};

type Detail = {
  /**
   * Message ID
   */
  messageId: string;

  /**
   * Message
   */
  message: string;
};
